import { SVGProps, Ref, forwardRef } from 'react';

export const HieroglyphLetterOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1 4.1h7.1V1h1.8v3.1H17v1.8h-4.121c-.11 2.312-.662 4.639-1.902 6.478q-.283.42-.611.8c1.013.574 2.214.919 3.615.922l1.786-5h2.269L23 23h-1.911l-1.108-3.1h-6.16L12.714 23h-1.911l2.543-7.12c-1.724-.109-3.174-.645-4.375-1.44-1.316.92-2.99 1.46-5.059 1.46q-1.117-.001-2.094-.205l.364-1.762a8.5 8.5 0 0 0 1.73.167c1.47 0 2.65-.318 3.598-.863-1.43-1.441-2.362-3.272-2.872-4.98l1.724-.515c.472 1.58 1.307 3.164 2.556 4.356q.308-.342.566-.726c.985-1.461 1.483-3.402 1.592-5.472H1zm18.339 14L16.9 11.275 14.464 18.1z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
HieroglyphLetterOutlinedSize24Glyph.displayName = 'HieroglyphLetterOutlinedSize24Glyph';
